<template>
    <div>
        <h2>Dispatchers</h2>

        <el-button 
            type="primary"
            @click="show_dialogs.create_dialog = true"
            style="margin: 15px 0"
        >Create a dispatcher</el-button>

        <draggable
            :list="dispatchers"
            :disabled="false"
            class="list-group"
            ghost-class="ghost"
            v-bind="drag_options"
            @change="(obj) => orderChanged(obj)"
            @start="drag = true"
            @end="drag = false"
            v-loading="loading"
        >
            <transition-group type="transition" :name="!drag ? 'flip-list' : null">
                <dispatcher-list-row 
                    v-for="(dispatcher, key) in dispatchers"
                    :key="dispatcher.id"
                    :dispatcher="dispatcher"
                    @updated="refresh"
                >
                </dispatcher-list-row>
            </transition-group>
        </draggable>

        <dispatcher-dialog-create
            :show="show_dialogs.create_dialog"
            @close="show_dialogs.create_dialog = false"
            @updated="refresh"
        >
        </dispatcher-dialog-create>
    </div>
</template>

<script>
import draggable from 'vuedraggable'
import DispatcherListRow from "./dispatcher-list-row";
import DispatcherDialogCreate from "./dispatcher-dialog-create";

export default {
        components: {
            draggable,
            DispatcherListRow,
            DispatcherDialogCreate
        },
        props: [
            'data'
        ],
        data() {
            return {
                loading: false,
                drag: false,
                drag_options: {
                    animation: 200,
                    group: "description",
                    disabled: false,
                    ghostClass: "ghost"
                },
                dispatchers: this.data.dispatchers,
                show_dialogs: {
                    create_dialog: false
                }
            }
        },
        methods: {
            refresh() {
                this.loading = true;

                return axios.get(url(`admin/settings/dispatchers/data`))
                    .then((response) => {
                        this.dispatchers = response.data;
                    }).finally(() => {
                        this.loading = false;
                    });
            },
            orderChanged(obj) {
                this.loading = true;

                let orderedDispatchers =_.map(this.dispatchers, 'id');

                return axios.post(url(`admin/settings/dispatchers/sort`), {
                        dispatchers: orderedDispatchers
                    })
                    .then((response) => {
                    }).finally(() => {
                        this.loading = false;

                        // this.$message({
                        //     message: `Dispatchers list has been reordered.`,
                        //     type: 'success'
                        // });
                    });
            }
        }
    }
</script>

<style>
    .ghost {
        opacity: 0.5;
        background: #c8ebfb !important;
    }
    .list-group {
        padding: 10px;
        background: #f9f9f9;
    }
    .inactive-item {
        background: #eeeeee;
    }
</style>